import { ILearningEntry } from '../interface/learningEntry'

export const CLearningEntry: ILearningEntry = {
    ReasonForInaktivation: "",
    changeActiveByOn: "",
    confirmed: "",
    createdOn: "",
    creationToday: "",
    entryDate: "",
    fromTime: "",
    hasComment: "",
    id: "",
    isActive: "",
    learningMedium_text: "",
    learningMedium_text_short: "",
    learningTopic_1: "",
    tillTime: "",
}
